<div class="scanner-chart-container">
  <!-- Loading State -->
  <div *ngIf="isLoading || (scoreLoading$ | async)" class="loading-state">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <!-- Error State -->
  <div
    *ngIf="hasError && !isLoading && (scoreLoading$ | async) === false"
    class="error-state"
  >
    <span class="error-message">{{ errorMessage }}</span>
  </div>

  <!-- Chart -->
  <app-combination-chart
    *ngIf="
      !isLoading &&
      (scoreLoading$ | async) === false &&
      !hasError &&
      chartData.length > 0
    "
    [chartData]="chartData"
    [showLegend]="true"
    [tooltipOptions]="tooltipOptions"
    [dualYAxis]="dualYAxis"
    [scoreType]="scoreType"
    [yAxisTitle]="yAxisTitle"
    [secondYAxisTitle]="secondYAxisTitle"
  ></app-combination-chart>
</div>
